




































import { SXChoice } from "@/gobl.bundle";
import BaseComponent from "@/components/BaseComponent.vue";
import { Component, Prop, Emit, Watch } from "vue-property-decorator";

const getForm = function() {
	return {
		fields: {
			min: {
				field: "input",
				label: { i18n: "SX_LANG_CHOICES_MIN_COUNT" },
				attrs: {
					type: "number",
					min: 0,
					name: "min",
					autocomplete: "off"
				},
				i18n: "SX_LANG_CHOICES_MIN_COUNT"
			},
			max: {
				field: "input",
				label: { i18n: "SX_LANG_CHOICES_MAX_COUNT" },
				attrs: {
					type: "number",
					min: 0,
					name: "max",
					autocomplete: "off"
				},
				i18n: "SX_LANG_CHOICES_MAX_COUNT"
			},
			others_choice: {
				field: "checkbox",
				label: { i18n: "SX_LANG_ADD_OTHERS_CHOICE" },
				attrs: {
					name: "others_choice"
				},
				i18n: "SX_LANG_ADD_OTHERS_CHOICE"
			}
		}
	};
};

@Component
export default class WQtypeCheckbox extends BaseComponent {
	@Prop({ type: Object, required: true })
	options!: any;

	@Watch("options.choices", { deep: true })
	watchOptionsChoices() {
		this.onOptionsChange();
	}

	get form() {
		return getForm();
	}

	toggleOthersChoice(e: any) {
		this.options.othersChoice = !!e.target.checked;
	}

	checkChoices() {
		let len = this.options.choices.length,
			valid = !!len,
			i;

		for (i = 0; i < len; i++) {
			let ch: SXChoice = this.options.choices[i];
			if (!ch.label.length) {
				valid = false;
				break;
			}
		}

		return valid;
	}

	@Emit("type-state-change")
	onOptionsChange() {
		let len = this.options.choices.length,
			min = this.options.min || 0,
			max = this.options.max || len,
			state = false;

		if (len) {
			if (this.options.othersChoice) {
				len++;
			}

			state =
				min >= 0 &&
				min < len &&
				(max ? min <= max && max <= len : true);
		}

		return state && this.checkChoices();
	}

	mounted() {
		this.onOptionsChange();
	}
}
